import * as React from "react";
import { rawTheme } from "styles/theme";
import { merge } from "glamor";
import XssSanitizedContent from "components/helpers/xss-sanitized-content";

interface IProps {
    product: any;
}
export class Description extends React.PureComponent<IProps, any> {
    private styles = merge({
        borderTop: `1px solid ${rawTheme.palette.lightGrey}`,
        color: rawTheme.palette.darkerGrey,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0.2px",
        paddingTop: "16px",
        marginTop: "16px",
    });

    render() {
        const { product } = this.props;
        if (!product.description) {
            return null;
        }

        return (
            <div {...this.styles}>
                <XssSanitizedContent content={product.description} />
            </div>
        );
    }
}
